import { inject, type InjectionKey, type Ref } from 'virtual-vue';
import type { TabBarIndex } from './tab-bar';

export interface TabBarProvide {
  /** 当前选中标签的索引 */
  activeIndex: Ref<TabBarIndex>;
  /** 更新子组件 */
  updateChild: (currentIndex: number | string) => void;
}

export const TAB_BAR_INJECT_KEY = Symbol('TAB_BAR_ITEM') as InjectionKey<TabBarProvide>;

/**
 * 获取TabBar的provide
 */
export function useTabBarInject() {
  const tabBar = inject(TAB_BAR_INJECT_KEY) as TabBarProvide;
  return tabBar;
}


